import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

const router = new Router({
    routes: [
        {
            
            path:'/',
            redirect:'/index'
        },
        {
            path: '/index',
            name:'index',
            component: resolve => require(['@/page/index_page/index.vue'], resolve),
            children: [
                // {
                //     path: '/index',
                //     component: resolve => require(['@/page/index_page/index.vue'], resolve)
                // } 
            ]
        }, 
        {
            // 营销资源
            path: '/yxzy', 
            component: resolve => require(['@/page/yxzy/index.vue'], resolve),
            children: [
                {
                    path:'/', 
                    redirect:'yxzy'
                },
                { 
                    path: 'yxzy',  
                    name:'yxzy',
                    component: resolve => require(['@/page/yxzy/yxzy_index.vue'], resolve)
                }, 
                { 
                    // 社团详情
                    path: 'team_detail', 
                    component: resolve => require(['@/page/yxzy/team_detail.vue'], resolve)
                },  
                { 
                    // 高校老师详情
                    path: 'teacher_detail', 
                    component: resolve => require(['@/page/yxzy/teacher_detail.vue'], resolve)
                },  
                { 
                    // 人员详情
                    path: 'user_detail', 
                    component: resolve => require(['@/page/yxzy/user_detail.vue'], resolve)
                }, 
                { 
                    // 机构详情
                    path: 'jg_detail', 
                    component: resolve => require(['@/page/yxzy/jg_detail.vue'], resolve)
                },  
                { 
                    // 场地详情
                    path: 'cd_detail', 
                    component: resolve => require(['@/page/yxzy/cd_detail.vue'], resolve)
                },  
                { 
                    // 高校场地详情
                    path: 'school_cd_detail', 
                    component: resolve => require(['@/page/yxzy/school_cd_detail.vue'], resolve)
                }
            ]

        },
        {
            // 营销案例
            path: '/yxal', 
            component: resolve => require(['@/page/yxal/index.vue'], resolve), 
            children: [
                {
                    path:'/',
                    redirect:'yxal'
                },
                { 
                    path: 'yxal', 
                    name: 'yxal',
                    component: resolve => require(['@/page/yxal/yxal_index.vue'], resolve)
                },
                { 
                    path: 'yxal_mcsj', 
                    component: resolve => require(['@/page/yxal/yxal_mcsj.vue'], resolve)
                } ,
                { 
                    path: 'yxal_detail', 
                    component: resolve => require(['@/page/yxal/yxal_detail.vue'], resolve)
                } ,
                { 
                    path: 'yxal_ldtp', 
                    component: resolve => require(['@/page/yxal/yxal_ldtp.vue'], resolve)
                } ,
                { 
                    path: 'yxal_yzwl', 
                    component: resolve => require(['@/page/yxal/yxal_yzwl.vue'], resolve)
                } 
            ]
        }, 
        {
            // 个人中心
            path: '/my',
            name: 'my',
            component: resolve => require(['@/page/my/index.vue'], resolve), 
            meta:{
                isAuth:true 
            },
            children: [
                { 
                    path: '/', 
                    component: resolve => require(['@/page/my/my_index.vue'], resolve),
                    children: [
                        { 
                            path: '/', 
                            redirect:'my_center'
                        }, 
                        { 
                            path: 'my_center',
                            meta:{
                                isAuth:true 
                            }, 
                            component: resolve => require(['@/page/my/my_center.vue'], resolve), 
                        }, 
                        { 
                            path: 'my_project',
                            meta:{
                                isAuth:true 
                            },  
                            component: resolve => require(['@/page/my/index.vue'], resolve), 
                            children: [
                                { 
                                    path: '/', 
                                    redirect:'my_project'
                                }, 
                                { 
                                    path: 'my_project',
                                    meta:{
                                        isAuth:true 
                                    },  
                                    component: resolve => require(['@/page/my/my_project.vue'], resolve), 
                                   
                                }, 
                                { 
                                    path: 'update_project', 
                                    meta:{
                                        isAuth:true 
                                    }, 
                                    component: resolve => require(['@/page/my/update_project.vue'], resolve), 
                                   
                                },
                                { 
                                    path: 'project_detail', 
                                    meta:{
                                        isAuth:true 
                                    }, 
                                    component: resolve => require(['@/page/my/project_detail.vue'], resolve), 
                                   
                                },
                            ]
                        },
                        { 
                            path: 'my_resources', 
                            meta:{
                                isAuth:true 
                            }, 
                            component: resolve => require(['@/page/my/my_resources.vue'], resolve), 
                        }
                    ]
                }, 
            ]
        } 
    ]  
})

// 全局前置 路由守卫 - 初始化的时候被调用 ，每次路由切换之前被调用 
router.beforeEach((to,from,next)=>{ 
    if(to.meta.isAuth){  // 判断是否需要鉴权
        if(localStorage.getItem('staff_id')){
            next()
        }else{ 
            // Vue.prototype.$message.error('无权查看，请登录之后再查看!') 
            next('/')   
        }
    }else{
        next()
    } 
 
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js